export const coRenterState = {
  address_1: '',
  address_2: '',
  birthdate: null,
  city: '',
  drivers_license: '',
  email: '',
  employer_address_1: '',
  employer_address_2: '',
  employer_city: '',
  employer_name: '',
  employer_phone: '',
  employer_state: '',
  employer_zip: '',
  first_name: '',
  home_phone: '',
  id: null,
  last_name: '',
  middle_name: '',
  drivers_license_image: null,
  proof_of_income_image: null,
  proof_of_residence_image: null,
  references: [
    { id: null, email: '', first_name: '', last_name: '', phone: '', relationship: ''  },
    { id: null, email: '', first_name: '', last_name: '', phone: '', relationship: ''  },
  ],
  state: '',
  zip: '',
}
